import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export function Pagination({ page, pageSize, total, onPageChange, testIdPrefix = 'pagination' }) {
    const totalPages = Math.max(1, Math.ceil(total / pageSize));
    if (total === 0) return null;
    const start = (page - 1) * pageSize + 1;
    const end = Math.min(page * pageSize, total);

    return (
        <div className="flex flex-wrap items-center justify-between gap-3 mt-4" data-testid={`${testIdPrefix}-bar`}>
            <p className="text-xs" style={{ color: 'var(--ink-muted)' }} data-testid={`${testIdPrefix}-summary`}>
                Showing <span className="font-medium" style={{ color: 'var(--brand-burgundy)' }}>{start}–{end}</span> of {total}
            </p>
            <div className="flex items-center gap-2">
                <button
                    onClick={() => onPageChange(page - 1)}
                    disabled={page <= 1}
                    data-testid={`${testIdPrefix}-prev`}
                    className="inline-flex items-center gap-1 px-3 py-1.5 rounded-lg text-xs uppercase tracking-[0.14em] border border-[rgba(90,36,50,0.18)] disabled:opacity-40 disabled:cursor-not-allowed hover:bg-[var(--brand-rose)]/40 transition-colors"
                    style={{ color: 'var(--brand-burgundy)' }}
                >
                    <ChevronLeft className="w-3.5 h-3.5" /> Prev
                </button>
                <span className="text-xs px-2" style={{ color: 'var(--ink-muted)' }} data-testid={`${testIdPrefix}-page`}>
                    Page {page} of {totalPages}
                </span>
                <button
                    onClick={() => onPageChange(page + 1)}
                    disabled={page >= totalPages}
                    data-testid={`${testIdPrefix}-next`}
                    className="inline-flex items-center gap-1 px-3 py-1.5 rounded-lg text-xs uppercase tracking-[0.14em] border border-[rgba(90,36,50,0.18)] disabled:opacity-40 disabled:cursor-not-allowed hover:bg-[var(--brand-rose)]/40 transition-colors"
                    style={{ color: 'var(--brand-burgundy)' }}
                >
                    Next <ChevronRight className="w-3.5 h-3.5" />
                </button>
            </div>
        </div>
    );
}
